var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 86.1",
    style: {
      enableBackground: "new 0 0 100 86.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ADADAD;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100,43.1C100,43.1,100,43.1,100,43.1c0-6.9-12.5-6.9-17-6.8v0H64.1C55.8,26,49,14.8,41.2,4.1 c-2.6-5.6-13.9-3.9-13.9-3.9s11.9,23.9,17.9,36H17.6c-3.2-3.6-6.2-7.1-9.3-10.5c-1.9-2.1-7.1-1.5-8.3-1.3l9.8,18.7L0.1,61.6 c9.5,1.6,11.6-6,17.3-11.7h27.8c-6,12.1-17.9,35.9-17.9,35.9s10.6,1.9,13.5-2.9c6.9-10,13.8-20,20.7-30c1.2-1.7,1.8-2.5,2.6-3H83v0 c4.2,0,15.2,0,16.8-5.4C100,44,100,43.6,100,43.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneIcon);
export default __webpack_public_path__ + "static/media/plane-icon.f518d4762c8e4e655eaafbec416ab1e1.svg";
export { ForwardRef as ReactComponent };